import React from 'react';
import { CustomVideo } from './styles';

import PropTypes from 'prop-types';

function Video({ videoId, autoplay = 0 }) {
  return (
    <CustomVideo
      videoId={videoId}
      opts={{
        playerVars: {
          autoplay,
        },
      }}
    />
  );
}

Video.propTypes = {
  videoId: PropTypes.string,
  autoplay: PropTypes.number,
  poster: PropTypes.string,
  primaryColor: PropTypes.string,
};

export default Video;
